export const jobListings = [
  {
    id: '1',
    slug: 'senior-backend-developer',
    title: 'Senior Backend Developer',
    location: 'Hà Nội',
    type: 'Toàn thời gian',
    category: 'tech'
  },
  {
    id: '2',
    slug: 'ui-ux-designer',
    title: 'UI/UX Designer',
    location: 'Thái Nguyên',
    type: 'Toàn thời gian',
    category: 'design'
  },
  {
    id: '3',
    slug: 'it-project-manager',
    title: 'IT Project Manager',
    location: 'Hà Nội',
    type: 'Toàn thời gian',
    category: 'management'
  }
];

export const careerValues = [
  {
    id: '1',
    title: 'Môi trường Agile',
    description: 'Quy trình hiện đại, linh hoạt và không ngừng sáng tạo.',
    icon: 'psychology'
  },
  {
    id: '2',
    title: 'Lộ trình rõ ràng',
    description: 'Chính sách đào tạo và phát triển năng lực được ưu tiên hàng đầu.',
    icon: 'trending_up'
  },
  {
    id: '3',
    title: 'Công nghệ tiên phong',
    description: 'Luôn tiếp cận và ứng dụng các công nghệ mới nhất trên thế giới.',
    icon: 'rocket_launch'
  },
  {
    id: '4',
    title: 'Văn hóa mở',
    description: 'Khuyến khích chia sẻ ý tưởng và trao quyền quyết định cho mỗi cá nhân.',
    icon: 'forum'
  },
  {
    id: '5',
    title: 'Chăm sóc toàn diện',
    description: 'Đãi ngộ hấp dẫn, bảo hiểm sức khỏe cao cấp cho nhân viên và gia đình.',
    icon: 'medical_services'
  },
  {
    id: '6',
    title: 'Cân bằng cuộc sống',
    description: 'Thời gian làm việc linh hoạt, chú trọng sự gắn kết qua các hoạt động teambuilding.',
    icon: 'self_improvement'
  }
];
